var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 436,
    viewBox: "0 0 517 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_2173)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.261 358.574L144.228 361.745C136.494 368.177 129.216 375.119 122.597 382.286C88.1077 419.628 66.5251 469.029 56.6044 533.327L52.8532 533.286C62.9555 467.942 84.9487 417.676 120.174 379.555C126.931 372.216 134.389 365.177 142.293 358.592L142.261 358.574Z",
    fill: "#83E4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.612 179.387C376.272 184.798 373.723 190.14 371.156 195.221C366.196 204.935 360.75 214.12 354.988 222.476C345.595 236.107 335.101 247.96 323.709 257.752C320.021 260.945 316.189 263.956 312.285 266.727C291.454 281.578 267.4 292.842 241.919 304.791L240.904 305.262C227.592 311.51 212.462 318.62 197.721 326.502L196.508 322.812C211.323 314.872 226.506 307.742 239.87 301.474L240.885 301.004C266.155 289.134 290.051 277.929 310.532 263.328C314.308 260.635 318.045 257.719 321.637 254.622C332.658 245.118 342.896 233.568 352.042 220.296C357.665 212.111 362.983 203.152 367.866 193.645C370.421 188.656 372.874 183.41 375.203 178.092L378.581 179.369L378.612 179.387Z",
    fill: "#83E4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.752 68.3124C406.749 68.6101 404.598 97.6144 394.436 134.192L390.808 133.571C400.827 97.4624 402.919 68.9243 402.954 68.6445L406.752 68.3124Z",
    fill: "#83E4FE"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M325.699 162.211C284.932 177.538 258.013 224.732 265.573 267.623C273.133 310.515 312.309 332.86 353.075 317.534C393.842 302.208 420.761 255.013 413.201 212.122C405.642 169.231 366.465 146.885 325.699 162.211Z",
    fill: "url(#paint0_radial_1064_2173)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M325.699 162.211C284.932 177.538 258.013 224.732 265.573 267.623C273.133 310.515 312.309 332.86 353.075 317.534C393.842 302.208 420.761 255.013 413.201 212.122C405.642 169.231 366.465 146.885 325.699 162.211Z",
    fill: "url(#paint1_radial_1064_2173)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M224.184 279.38C202.958 267.273 173.928 278.187 159.343 303.757C144.758 329.327 150.142 359.87 171.367 371.977C192.593 384.084 221.623 373.17 236.208 347.6C250.793 322.03 245.41 291.487 224.184 279.38Z",
    fill: "url(#paint2_radial_1064_2173)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M224.184 279.38C202.958 267.273 173.928 278.187 159.343 303.757C144.758 329.327 150.142 359.87 171.367 371.977C192.593 384.084 221.623 373.17 236.208 347.6C250.793 322.03 245.41 291.487 224.184 279.38Z",
    fill: "url(#paint3_radial_1064_2173)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M138.154 350.231C116.928 338.124 87.8978 349.038 73.313 374.609C58.7281 400.179 64.1115 430.722 85.3371 442.829C106.563 454.935 135.593 444.021 150.178 418.451C164.763 392.881 159.379 362.338 138.154 350.231Z",
    fill: "url(#paint4_radial_1064_2173)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M138.154 350.231C116.928 338.124 87.8978 349.038 73.313 374.609C58.7281 400.179 64.1115 430.722 85.3371 442.829C106.563 454.935 135.593 444.021 150.178 418.451C164.763 392.881 159.379 362.338 138.154 350.231Z",
    fill: "url(#paint5_radial_1064_2173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1064_2173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(339.383 239.878) rotate(-150.3) scale(71.2312 85.8105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1064_2173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(339.383 239.878) rotate(-150.3) scale(71.2312 85.8105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1064_2173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.776 325.678) rotate(-150.3) scale(44.2448 53.3006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1064_2173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.776 325.678) rotate(-150.3) scale(44.2448 53.3006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1064_2173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.745 396.53) rotate(-150.3) scale(44.2448 53.3006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1064_2173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.745 396.53) rotate(-150.3) scale(44.2448 53.3006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_2173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 517,
    height: 436,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line2.5b6b750cfff53813b46e3da1c63024a2.svg";
export { ForwardRef as ReactComponent };